export const formatSatoshis = (satoshiPrice: number | bigint): string => {
	if (typeof satoshiPrice === 'bigint') {
		const sign = satoshiPrice < 0n ? '-' : ''
		const amount = satoshiPrice < 0n ? -satoshiPrice : satoshiPrice
		return `${sign}${amount / 100000000n}.${(amount % 100000000n).toString().padStart(8, '0')}`
	}
	if (typeof satoshiPrice !== 'number' && !satoshiPrice) return '0'
	const amount = Number(satoshiPrice)
	if (!Number.isFinite(amount)) return '0'
	// Round in satoshi units before converting. Dividing and multiplying by 1e8
	// before flooring can turn 3,268,242 sats into 3,268,241 through float error.
	return (Math.floor(amount) / 100000000).toFixed(8)
}

export default function useSatoshiPrice(satoshiPrice: number | bigint): string {
	return formatSatoshis(satoshiPrice)
}
